import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GenerateChartIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "GenerateChart",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.38 7.92h-2.2c-.89 0-1.62.72-1.62 1.62v16.69h-2.1V4.15c0-.87-.7-1.59-1.57-1.61h-2.21c-.89 0-1.62.72-1.62 1.62v22.03h-2.15V11.7c0-.89-.72-1.62-1.62-1.62h-2.2c-.89 0-1.62.72-1.62 1.62v14.54H7.41v-9.15c0-.89-.72-1.62-1.62-1.62h-2.2c-.89 0-1.62.72-1.62 1.62v10.77c0 .89.72 1.62 1.62 1.62h24.77c.89 0 1.62-.72 1.62-1.62V9.49a1.62 1.62 0 0 0-1.61-1.57Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M2 27.71c-.63 0-1.14-.51-1.14-1.14V22c0-.63.51-1.14 1.14-1.14h2.29a1.14 1.14 0 1 1 0 2.28H3.15v3.43c0 .63-.51 1.14-1.14 1.14ZM8.86 27.71c-.63 0-1.14-.51-1.14-1.14V16.28c0-.63.51-1.14 1.14-1.14h2.29a1.14 1.14 0 1 1 0 2.28h-1.14v9.14c0 .63-.51 1.14-1.14 1.14ZM15.71 27.71c-.63 0-1.14-.51-1.14-1.14V6c0-.63.51-1.14 1.14-1.14h5.71a1.14 1.14 0 1 1 0 2.28h-4.57v19.43c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M29.43 27.71c-.63 0-1.14-.51-1.14-1.14V11.71h-4.57v14.86a1.14 1.14 0 1 1-2.28 0v-16c0-.63.51-1.14 1.14-1.14h6.86c.63 0 1.14.51 1.14 1.14v16c0 .63-.51 1.14-1.14 1.14Z"
      })]
    })
  }));
};